/* eslint-disable react/no-unstable-nested-components */
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import HeaderFilters from "components/Shared/HeaderFilters/HeaderFilters"
import React, { useEffect, useState } from "react"
import { Pagination, Search } from "@wfp/ui"
import BaseTable, { AutoResizer, ColumnShape } from "react-base-table"
import Button from "components/Shared/Button/Button"
import { useGetCategoriesQuery } from "services/core/commodities"
import { CategoriesData } from "interfaces/dataInterfaces"
import { GET_ITEM_LIMIT } from "constants/constants"

export default function CategoriesPage() {
  const [pageNumber, setPageNumber] = useState(1)
  const [getItemLimit, setGetItemLimit] = useState(GET_ITEM_LIMIT)
  const [query, setQuery] = useState<string | undefined>("")
  const [inputText, setInputText] = useState<string | undefined>(undefined)

  const { data: categories } = useGetCategoriesQuery({
    skip: pageNumber === 1 ? 0 : (pageNumber - 1) * getItemLimit,
    take: getItemLimit,
    query,
  })

  const columns: Array<ColumnShape<CategoriesData>> = [
    {
      key: "commodityCategoryID",
      dataKey: "commodityCategoryID",
      title: "ID",
      width: 180,
      maxWidth: 180,
    },
    {
      key: "commodityCategoryName",
      dataKey: "commodityCategoryName",
      title: "Name",
      width: 400,
    },
  ]
  const handleSearch = (e: any) => {
    setInputText(e)
  }

  const handleSubmitQuery = () => {
    setPageNumber(1)
    setQuery(inputText)
  }

  const handleSearchKey = (e: any) => {
    inputText && e?.code === "Enter" && handleSubmitQuery()
  }

  useEffect(() => {
    !inputText && query && setQuery("")
  }, [inputText])

  return (
    <>
      <HeaderFilters>
        <div className="d-flex" style={{ width: "300px" }}>
          <Search
            id="query"
            name="query"
            placeholder="Type here to filter results..."
            className="text-input mr-2"
            value={query}
            onChange={e => handleSearch(e)}
            onKeyUp={e => handleSearchKey(e)}
          />
          <Button action={handleSubmitQuery} label="Search" className="btn-full blue" icon={faSearch} />
        </div>
      </HeaderFilters>
      <div style={{ height: "100%", minHeight: "60vh" }} className="mt-2">
        <AutoResizer>
          {({ width, height }) => (
            <BaseTable
              data={categories?.items}
              width={width}
              height={height}
              rowKey="commodityCategoryID"
              className="custom-table"
              rowHeight={38}
              headerHeight={45}
              columns={columns}
              emptyRenderer={() => <p>No records to display</p>}
            />
          )}
        </AutoResizer>
      </div>
      <Pagination
        totalItems={categories?.count ?? 0}
        pageSize={getItemLimit}
        pageSizes={[10, 20, 30]}
        page={pageNumber}
        onChange={(event: any): void => {
          setPageNumber((event as any).page)
          setGetItemLimit((event as any).pageSize)
        }}
      />
    </>
  )
}
